import { FC } from "react";
import { useStyle } from "./ExternalAccounts.styles";
import { Tabs } from "@mantine/core";
import PaymentsListing from "./Tabs/PaymentsListing";
import CollectionsListing from "./Tabs/CollectionsListing";
import BalancesListing from "./Tabs/BalancesListing";
import ExchangeRate from "./Tabs/ExchangeRate";

const ExternalAccounts: FC = () => {
  const { classes } = useStyle();

  return (
    <div>
      <div>
        <h1 className={classes.headerText}>External Accounts</h1>
      </div>

      <Tabs defaultValue="paymentsListing">
        <Tabs.List>
          <Tabs.Tab value="paymentsListing">Payments Listing</Tabs.Tab>
          <Tabs.Tab value="collectionsListing">Collections Listing</Tabs.Tab>
          <Tabs.Tab value="balancesListing">Balances Listing</Tabs.Tab>
          <Tabs.Tab value="exchangeRate">Exchange Rate</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="paymentsListing" pt="xs">
          <PaymentsListing />
        </Tabs.Panel>

        <Tabs.Panel value="collectionsListing" pt="xs">
          <CollectionsListing />
        </Tabs.Panel>

        <Tabs.Panel value="balancesListing" pt="xs">
          <BalancesListing />
        </Tabs.Panel>

        <Tabs.Panel value="exchangeRate" pt="xs">
          <ExchangeRate />
        </Tabs.Panel>
      </Tabs>
    </div>
  );
};

export default ExternalAccounts;
